import { CSSProperties, forwardRef, MouseEventHandler } from 'react';
import styles from './ToggleMonochrome.module.scss';
import { Icon, IconProps } from '@ets/design-system';

type ToggleMonochromeProps = {
  expanded: boolean;
  iconProps?: Omit<IconProps, 'testId' | 'size'>;
  suffix?: IconProps['icon'];
  isToggled: boolean;
  testId: string;
  onClick: MouseEventHandler<HTMLSpanElement>;
  children: React.ReactNode;
  margin?: CSSProperties['margin'];
  loading?: boolean;
};

const ToggleMonochrome = forwardRef<HTMLDivElement, ToggleMonochromeProps>(
  ({ expanded, iconProps, suffix, isToggled, testId, onClick, children, margin, loading }, ref) => {
    return (
      <span
        ref={ref}
        className={`${styles.container} ${expanded ? styles.expanded : ''}`}
        style={{
          margin,
          justifyContent: suffix ? 'space-between' : 'flex-start',
        }}
        onClick={onClick}
        data-testid={testId}
        data-selected={isToggled}
      >
        {loading ? (
          <>
            <span className={styles.loadingIcon} />
            {expanded && <span className={styles.loadingPlaceholder}>{children}</span>}
          </>
        ) : (
          <>
            {iconProps && <Icon {...iconProps} color="light" size="3" testId={testId} />}
            {expanded && <span className={styles.content}>{children}</span>}
            {suffix && <Icon icon={suffix} size="3" testId={testId} />}
          </>
        )}
      </span>
    );
  },
);

export default ToggleMonochrome;
